<!-- 图片裁切子组件 -->
<template>
  <div>
    <a-modal
      title="裁切图片"
      :visible="cut_visible"
      :confirm-loading="cut_confirmLoading"
      @ok="cutHandleOk"
      @cancel="cutHandleCancel"
      width="1200px"
      okText="确认"
    >
      <div
        :style="{ width: cropper_width + 'px', height: cropper_height + 'px' }"
        style="margin: auto"
        :key="cor_option.img"
        v-if="cor_option.img"
      >
        <vueCropper
          ref="cropper"
          mode="100%"
          :img="cor_option.img"
          :outputSize="cor_option.size"
          :outputType="cor_option.outputType"
          :canScale="false"
          :info="true"
          :full="cor_option.full"
          :fixed="true"
          :fixed-number="fixedNumber"
          :can-move="cor_option.canMove"
          :can-move-box="cor_option.canMoveBox"
          :fixed-box="cor_option.fixedBox"
          :original="cor_option.original"
          :auto-crop="cor_option.autoCrop"
          :auto-crop-width="cor_option.autoCropWidth"
          :auto-crop-height="cor_option.autoCropHeight"
          :center-box="cor_option.centerBox"
        ></vueCropper>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
export default {
  name: "cropperImgModal_",
  props: {},
  components: {
    VueCropper,
  },
  data() {
    return {
      cut_visible: false, // 裁切图片
      cut_confirmLoading: false, // 裁切图片弹窗确认按钮加载状态
      cut_img: "", // 要裁切的图片
      cor_option: {
        img: "",
        size: 1,
        full: false,
        outputType: "jpeg",
        canMove: false,
        fixedBox: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 1080,
        autoCropHeight: 864,
        centerBox: true, // 截图框是否被限制在图片里面
        high: true,
        max: 99999,
      },

      show: true,
      fixed: true,
      fixedNumber: [1080, 864],
      cropper_width: 0,
      cropper_height: 0,
      cropper_w_h: 1, // 原图与实际图的比值
      cropper_original_img_url: "", // 要进行裁切的原图链接
    };
  },
  methods: {
    cutImgHandle(c_img) {
      let that = this;
      this.cor_option.img = c_img;
      // 单图文的话，裁切比例就是1:1正方形
      // this.fixedNumber = [1080,864] ;
      var img = new Image();
      img.src = this.cor_option.img;
      img.onerror = function () {
        alert(" 图片加载失败，请检查url是否正确");
        return false;
      };

      function img_ifo() {
        // console.log(img.width,img.height)

        if (img.width < 1080) {
          const rate = 1080 / img.width;
          that.cropper_width = 1080;
          that.cropper_height = img.height * rate;
        }
        // that.cropper_width = 1080;
        // that.cropper_height = 1080;
        that.cut_visible = true;
      }
      if (img.complete) {
        img_ifo();
      } else {
        img.onload = function () {
          img.onload = null; //避免重复加载
          img_ifo();
        };
      }
    },
    cutHandleOk(e) {
      let that = this;
      let data = this.$refs.cropper.getCropAxis();
      let w = Math.round(data.x2 - data.x1);
      let h = Math.round(data.y2 - data.y1);
      let x = Math.round(data.x1);
      let y = Math.round(data.y1);

      let s_w, s_h, s_x, s_y;
      if (that.cropper_w_h < 1) {
        // 表示实际图片尺寸大于显示尺寸
        s_w = Math.round(w / that.cropper_w_h);
        s_h = Math.round(h / that.cropper_w_h);
        s_x = Math.round(x / that.cropper_w_h);
        s_y = Math.round(y / that.cropper_w_h);
      } else {
        // 表示实际图片尺寸小于或者等于显示尺寸
        s_w = Math.round(w);
        s_h = Math.round(h);
        s_x = Math.round(x);
        s_y = Math.round(y);
      }
      let oss_text = `?x-oss-process=image/crop,x_${s_x},y_${s_y},w_${s_w},h_${s_h}`;

      // 这里需要再做一个处理，当图片链接本身就有这些x,y,w,h参数时，要进行去除
      let img_data = this.cor_option.img.split("?"); // 把图片链接后面的参数去掉

      let c_img = img_data[0] + oss_text;
      this.$emit("cropper-ok", c_img);

      // this.cut_visible = false
    },
    cutHandleCancel() {
      this.cut_visible = false;
    },
  },
};
</script>

<style scoped></style>
